import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Spinner,
} from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { FaUpload } from "react-icons/fa";
import "../../css/client/uploadDocument.css";
import AdminScreenHeader from "../admin/adminScreenHeader";
import {
  uploadDoc,
  apiPost,
  downloadDoc,
} from "../../service/admin/apiService";
import Loader from "../loader";
import { showError, showSuccess } from "../../utils/toast";
import DateFilters from "./dateFilters";
import { useLocation } from "react-router-dom";
import { getImage } from "../../utils/admin/misc";

const UploadDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [formFinancialYear, setFormFinancialYear] = useState([]);
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  const [reuploadDocId, setReuploadDocId] = useState(null);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
  const [downloadingId, setDownloadingId] = useState(null);
  const [selectedClient, setSelectedClient] = useState("");
  const [clientList, setClientList] = useState([]);
  const fileInputRef = useRef(null);
  const location = useLocation();
  let tk = localStorage.getItem("tk");
  let ui = localStorage.getItem("ui");

  const isAdmin = location.pathname === "/client-document";
  const isClient = location.pathname === "/upload-document";

  useEffect(() => {
    if (isAdmin) {
      getClientList();
    }
  }, [isAdmin]);

  const getClientList = async () => {
    setShowLoader(true);
    const payload = {
      action: "userclientlinklist",
      to: tk,
      ui: ui,
    };

    if (tk && tk !== "") {
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);
        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("clientlist", response?.responsedetails);
          const clist = response?.responsedetails?.filter((el) => el.li != 0);
          if (clist) {
            setClientList(clist);
            setShowLoader(false);
          }
        }
      } catch (err) {
        console.error("Error:", err);
        setShowLoader(false);
      }
    }
  };

  const getDocuments = async () => {
    setShowLoader(true);
    const payload = {
      action: "listdocument",
      to: isAdmin ? tk : clientInfo?.tk,
      fi: selectedFYearId,
      dmo: selectedMonth,
      clid: selectedClient,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (response?.responsedetails) {
        console.log("image response", response?.responsedetails);
        setDocuments(response?.responsedetails);
        setShowLoader(false);
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };

  const setSelectedFile = (event) => {
    const fl = event.target.files[0];
    if (fl) {
      setFile(fl);
    }
  };

  const handleFileUpload = async () => {
    if (loading) return;

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    setLoading(true);

    // const docIdToReplace = reuploadId || reuploadDocId;

    const payload = {
      action: "adddocument",
      to: isAdmin ? tk : clientInfo?.tk,
      dn: file.name,
      clid: isAdmin ? selectedClient : clientInfo?.client?.id,
      fi: selectedFYearId,
      dmo: selectedMonth,
      rm: "Document Uploaded",
      ic: "0",
    };

    console.log("payload", payload);

    const formData = new FormData();
    formData.append("fileToUpload", file);
    formData.append("data", JSON.stringify(payload));

    try {
      const response = await uploadDoc(process.env.REACT_APP_API_URL, formData);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setLoading(false);
      } else if (response?.responsedetails) {
        console.log("response", response?.responsedetails);
        if (response?.responsedetails?.success === "yes") {
          setTimeout(() => {
            setLoading(false);
            showSuccess("Document uploaded successfully!!!");
            clearFileInput();
            getDocuments();
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const handleFileDonwload = async (docId, docName) => {
    if (isAdmin ? tk : clientInfo?.tk && isAdmin ? tk : clientInfo?.tk !== "") {
      setDownloadingId(docId);
      try {
        const payload = {
          action: "downloaddocument",
          to: isAdmin ? tk : clientInfo?.tk,
          id: docId,
        };

        const response = await downloadDoc(
          process.env.REACT_APP_API_URL,
          payload,
          docName
        );
        console.log("res", response);
        setDownloadingId(null);
      } catch (error) {
        setDownloadingId(null);
        console.error("Download failed:", error);
      }
    }
  };

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Container fluid className="p-md-4 form24q-container">
      <div className="mt-3">
        <AdminScreenHeader title="📋 Upload Document" showSearch={false} />
        {isAdmin ? (
          <Form.Group className="mb-3">
            <Form.Label className="textbox-label">Client Name</Form.Label>
            <Form.Select
              value={selectedClient}
              onChange={(e) => [setSelectedClient(e.target.value)]}
              style={{ fontSize: "13px" }}
            >
              <option value="">Select Client</option>
              {clientList.map((client) => (
                <option key={client.ci} value={client.ci}>
                  {`${client.cn}`}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        ) : null}
        <DateFilters
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedQuarter={selectedQuarter}
          setSelectedQuarter={setSelectedQuarter}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          getFormInfo={getDocuments}
          setSelectedFYearId={setSelectedFYearId}
          setFormInfo={setDocuments}
          setFormFinancialYear={setFormFinancialYear}
        />

        <div className="d-flex justify-content-center mt-3">
          <div style={{ width: "500px" }}>
            <Form.Group
              controlId="formFileMultiple"
              className="mb-4 text-center"
            >
              <h5 className="text-primary">Select Document(s)</h5>

              <div className="d-flex justify-content-center align-items-center gap-2">
                <Form.Control
                  type="file"
                  multiple
                  accept="image/*"
                  size="md"
                  ref={fileInputRef}
                  onChange={(e) => setSelectedFile(e)}
                  className="text-primary"
                  style={{ maxWidth: "300px", fontSize: "13px" }}
                />

                <Button
                  size="sm"
                  variant="primary "
                  className="mb-1 mt-1  d-flex align-items-center gap-2"
                  onClick={() => {
                    handleFileUpload();
                  }}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Uploading...
                    </>
                  ) : (
                    <>
                      Upload
                      <FaUpload size={15} />
                    </>
                  )}
                </Button>
              </div>
            </Form.Group>
          </div>
        </div>
        <hr />
        <Row xs={1} md={2} className="g-4">
          {documents?.map((doc, idx) => (
            <Col key={idx} className="d-flex justify-content-center col-width">
              <Card>
                <div className="d-flex justify-content-end">
                  {downloadingId === doc.id ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      className="me-2 mt-1 mb-1"
                      style={{ color: "white" }}
                    />
                  ) : (
                    <BsDownload
                      className="me-2 mt-1 mb-1"
                      style={{
                        color: "white",
                        fontSize: "1.2rem",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleFileDonwload(doc.id, doc.documentname);
                      }}
                    />
                  )}
                </div>
                <Card.Img
                  variant="top"
                  // src={`${process.env.REACT_APP_API_BASE_URL}/${doc.filepath}${doc.tempfilename}.${doc.tempfileextention}`}
                  src={getImage("extention_logo", doc.tempfileextention)}
                  alt={doc.name}
                  className="img-thumbnail mt-1 document-img mx-sm-0 mx-auto d-block d-sm-block"
                />
                <Card.Body>
                  <Card.Text className="mb-0 text-center">
                    <div style={{ textAlign: "center" }}>
                      {doc.documentname}
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default UploadDocuments;
